import moment from 'moment-timezone';
import { ChatConversation } from '../common';

export const TIME_OF_DAY_FORMAT = 'h:mma';

export const getFormattedDate = (date: string, timezone: string) => {
  return (
    <>
      <strong>
        {moment(date)
          .tz(timezone)
          .format(
            moment(date).isSame(new Date(), 'year') ? 'MMM D' : 'MMM D YYYY',
          )}
      </strong>
      ,{' '}
      {moment(date).tz(timezone).calendar({
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: 'dddd',
        lastWeek: 'dddd',
        sameElse: 'dddd',
      })}
    </>
  );
};

export const isLastMessage = (
  message: ChatConversation,
  messages: ChatConversation[],
) => {
  if (!messages.length) return;
  return (
    messages[messages.length - 1].chat_message_id === message.chat_message_id
  );
};
